import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { hubApiUrl } from './appsettings';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class ApiService {

  constructor(private http: Http) { }

  getForm(accountId:number, formId:number, userId:number, securityKey:string): Promise<any> {
    return this.http.get(`${hubApiUrl}${accountId}/form/${formId}/user/${userId}/info.json?k=${securityKey}`)
              .toPromise()
              .then(this.treatAnswer)
              .catch(this.errorCatch);
  }

  postForm(accountId:number, formId:number, userId:number, securityKey:string, formAnwer: Object): Promise<any> {
    return this.http.post(`${hubApiUrl}${accountId}/form/${formId}/user/${userId}/answer.json?k=${securityKey}`, {answer: JSON.stringify(formAnwer)})
              .toPromise()
              .then(this.treatAnswer)
              .catch(this.errorCatch);
  }

  private treatAnswer(res: Response): void {
    let result = res.json();
    return result || {};
  }

  private errorCatch(error: Response | any): Promise<string> {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''}`;
      return Promise.reject(body.detail);
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Promise.reject(errMsg);
  }


}



// WEBPACK FOOTER //
// ./src/app/api.service.ts